import { fetchGetJson } from '../../services/fetch-get-json'
import { attachBearerToken } from '../../services/attach-bearer-token'
import { getParam } from '../../helpers/parameters'

export const apiFetchContactOptions = async (
  preSaleFlag,
  language,
  customer
) => {
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  const contentApiUrl = await getParam('contentApiUrl')

  return fetchGetJson(
    `${contentApiUrl}/contactoptions?language=${language}` +
      `&customer=${customer}${preSaleURL}`,
    await attachBearerToken({ method: 'GET' })
  )
}



// WEBPACK FOOTER //
// ./src/containers/ContactUsModal/services.js